import { isStaffImportApiConfigured } from './staffImportApi';
import * as staffImportApi from './staffImportApi';
import * as staffImportMock from './staffImportMock';
import type { StaffImportGridRow } from '../types/staffImport';

declare const __STAFF_IMPORT_USE_MOCKS__: boolean;

const useMocks = () =>
    typeof __STAFF_IMPORT_USE_MOCKS__ !== 'undefined' &&
    __STAFF_IMPORT_USE_MOCKS__;

const selectEtlModule = () => {
    if (isStaffImportApiConfigured()) {
        return staffImportApi;
    }
    if (useMocks()) {
        return staffImportMock;
    }
    throw new Error('Staff import API is not configured.');
};

export const createImportJob = (
    fileName: string,
    options: { businessName: string },
) => selectEtlModule().createImportJob(fileName, options);

export const uploadImportJobArtifacts = (
    job: staffImportApi.CreateImportJobResult,
    file: File,
    signal?: AbortSignal,
) => selectEtlModule().uploadImportJobArtifacts(job, file, signal);

export const startWebCrawl = (url: string, options: { businessName: string }) =>
    selectEtlModule().startWebCrawl(url, options);

export const pollImportJobStatus = (
    jobId: string,
    options: {
        businessName: string;
        fileName?: string;
        importType: string;
        signal?: AbortSignal;
    },
) => selectEtlModule().pollImportJobStatus(jobId, options);

export const getLatestGeneratedImportJob = (options: {
    businessName: string;
    signal?: AbortSignal;
}) => selectEtlModule().getLatestGeneratedImportJob(options);

export const fetchImportJobData = (
    jobId: string,
    options: {
        businessName: string;
        fileName?: string;
        importType: string;
        signal?: AbortSignal;
    },
) => selectEtlModule().fetchImportJobData(jobId, options);

export const uploadCsv = (file: File, options: { businessName: string }) =>
    selectEtlModule().uploadCsv(file, options);

export const processImport = (
    fileName: string,
    rows: StaffImportGridRow[],
    options: { businessName: string; jobId: string },
) => {
    if (isStaffImportApiConfigured()) {
        return staffImportApi.processStaffImport({
            businessName: options.businessName,
            fileName,
            jobId: options.jobId,
            rows,
        });
    }
    if (useMocks()) {
        return staffImportMock.processImport(fileName, rows, options);
    }
    throw new Error('Staff import API is not configured.');
};
